let html = `<div class="account-add-device">
    <img class="account-add-device__qr" />

    <div class="about">
        #{account_code_where}
    </div>

    <div class="simple-button selector">#{account_code_input}</div>
</div>`

export default html